import { heroFeature, heroIndex } from "@/mocks/home";

export default function HomeHero() {
  return (
    <section id="deep" className="w-full px-4 md:px-8 pt-8 md:pt-12">
      <div className="flex items-center gap-4 mb-6 md:mb-8">
        <span className="font-label text-xs tracking-[0.3em] text-primary-600 whitespace-nowrap">
          今日要案
        </span>
        <span className="flex-1 h-px bg-background-300/70"></span>
        <span className="font-label text-xs text-foreground-400 whitespace-nowrap">
          编辑部深挖组 · 每日主推
        </span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
        <article className="lg:col-span-7 flex flex-col animate-fade-up">
          <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-800 font-label text-xs">
            <i className="ri-radar-line text-sm"></i>
            {heroFeature.kicker}
          </span>

          <h2 className="mt-5 font-heading font-bold text-3xl md:text-5xl leading-tight tracking-tight text-foreground-950">
            {heroFeature.title}
          </h2>

          <p className="mt-5 font-label text-sm md:text-base leading-relaxed text-foreground-600 max-w-2xl">
            {heroFeature.excerpt}
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {heroFeature.tags.map((tag) => (
              <a
                key={tag}
                href="#topics"
                className="px-3 py-1 rounded-md bg-secondary-100 text-secondary-900 font-label text-xs hover:bg-secondary-200 transition-colors cursor-pointer"
              >
                #{tag}
              </a>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-3 gap-4 border-y border-background-200/80 py-5">
            {heroFeature.stats.map((s) => (
              <div key={s.label}>
                <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  {s.value}
                </p>
                <p className="mt-1 font-label text-xs text-foreground-400">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-quill-pen-line text-sm"></i>
              {heroFeature.author}
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line text-sm"></i>
              阅读约 {heroFeature.readTime}
            </span>
            <span className="inline-flex items-center gap-1.5 text-primary-600">
              <i className="ri-node-tree text-sm"></i>
              含 9 段证据链
            </span>
          </div>
        </article>

        <div className="lg:col-span-5 animate-fade-up delay-100">
          <figure className="relative w-full h-[260px] sm:h-[340px] lg:h-[440px] rounded-lg overflow-hidden bg-background-200">
            <img
              src={heroFeature.image}
              alt={`黑料看料 深挖内幕主推：${heroFeature.title}`}
              title="黑料看料 内幕 真相 隐情"
              className="w-full h-full object-top object-cover"
            />
            <figcaption className="absolute left-4 bottom-4 right-4">
              <span className="inline-block px-3 py-1.5 rounded-md bg-background-50/90 backdrop-blur font-label text-xs text-foreground-700">
                图源：编辑部线索整理室
              </span>
            </figcaption>
          </figure>

          <div className="mt-3 grid grid-cols-2 gap-3">
            <div className="rounded-lg bg-accent-100 px-4 py-3">
              <p className="font-label text-xs text-accent-900">今日新增线索</p>
              <p className="mt-1 font-heading text-2xl font-bold text-accent-900">27</p>
            </div>
            <div className="rounded-lg bg-background-100 px-4 py-3">
              <p className="font-label text-xs text-foreground-500">待核实节点</p>
              <p className="mt-1 font-heading text-2xl font-bold text-foreground-800">6</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 md:mt-10 rounded-lg border border-background-200/80 bg-background-100/70 p-4 md:p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading text-lg font-semibold text-foreground-950">
            今日索引 · 正在深挖
          </h2>
          <a
            href="#collections"
            className="inline-flex items-center gap-1 font-label text-xs text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部合集
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
          {heroIndex.map((item) => (
            <a
              key={item.no}
              href="#deep"
              className="group rounded-md bg-background-50 border border-background-200/70 p-4 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className="font-heading text-2xl font-bold text-primary-300 group-hover:text-primary-500 transition-colors">
                {item.no}
              </span>
              <p className="mt-3 font-label text-sm leading-snug text-foreground-800">
                {item.title}
              </p>
              <p className="mt-3 font-label text-[11px] text-foreground-400">{item.meta}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}